"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataFallback = void 0;
const react_1 = __importDefault(require("react"));
const no_data_fallback_styles_1 = require("./no-data-fallback.styles");
const NoDataFallback = ({ icon, title, className, }) => (react_1.default.createElement(no_data_fallback_styles_1.StyledContainer, { className: className }, icon && react_1.default.createElement("div", { className: "icon" }, icon), react_1.default.createElement("div", { className: "text-block" }, react_1.default.createElement("span", { className: "text-block-title" }, title))));
exports.NoDataFallback = NoDataFallback;
exports.default = exports.NoDataFallback;
